import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnInit,
} from '@angular/core';
import { TransactionDetailsFormatterService } from '@rd/core//services/transaction-details-formatter/transaction-details-formatter.service';
import { IconRegistryService } from '@rd/core/services/icon-registry/icon-registry.service';
import { UrlUtilsService } from '@rd/core/services/url-utils/url-utils.service';
import { LoyaltyProgramHelper } from '@rd/helpers/loyalty-program.helper';
import { DynamicListItem } from '@rd/shared-legacy/components/dynamic-list/dynamic-list-item.type';
import {
  IconOptions,
  LoyaltyProgram,
  PointsTransferMembership,
} from '@rd/types';
import { Promocode } from '@rd/types/promocode.type';
import { TransferConnectV2SettingService } from '../../services/transfer-connect-v2-setting/transfer-connect-v2-setting.service';
import { EnrichedTransferConnectV2CheckoutFormData } from '../../types';

@Component({
  selector: 'rd-tcv2-review-body',
  templateUrl: './review-body.component.html',
  styleUrls: ['./review-body.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TcV2ReviewBodyComponent implements OnInit {
  @HostBinding('class.rd-tcv2-review-body') componentClass = true;
  @HostBinding('class.rounded-md') roundedMdClass = true;
  @Input() formData: EnrichedTransferConnectV2CheckoutFormData;
  @Input() loyaltyProgram: LoyaltyProgram;
  @Input() membership: PointsTransferMembership;
  @Input() pointsTransferLoading: boolean;
  @Input() promocode: Promocode | null;

  brandIconUrl: string;

  pointsTransferDetails: DynamicListItem[];
  flippableIconOptions: IconOptions = {
    flippable: true,
  };

  constructor(
    private iconRegistryService: IconRegistryService,
    private loyaltyProgramHelper: LoyaltyProgramHelper,
    private urlUtilsService: UrlUtilsService,
    private transactionDetailFormatterSvc: TransactionDetailsFormatterService,
    private transferConnectV2SettingService: TransferConnectV2SettingService,
  ) {}

  ngOnInit(): void {
    this.iconRegistryService.registerIcon('icn-transfer');
    this.brandIconUrl = this.urlUtilsService.imageUrl(
      '/images/branding/dark-logo.png',
    );

    const {
      firstName,
      lastName,
      number: accountNumber,
      dateOfBirth,
    } = this.membership;

    this.pointsTransferDetails =
      this.transactionDetailFormatterSvc.pointsTransferDetailsFormat({
        loyaltyProgram: this.loyaltyProgram,
        processingDelay:
          this.loyaltyProgram.pointsTransferCapability.processingDelay,
        pointsTransferData: {
          firstName,
          lastName,
          number: accountNumber,
          dateOfBirth,
        },
        tcv2Settings: this.transferConnectV2SettingService,
      });
  }

  loyaltyProgramImageUrl(): URL | null {
    return this.loyaltyProgram.pointsTransferCapability.logoUrl;
  }
}
